module.exports = __webpack_public_path__ + "resources/img/img_global_network_m.1a872d8c02ab482d8ecbf802a69a5507.png";